import React, { forwardRef, useEffect, useState } from "react";
import "./PosterTemplate.scss";
import ReactSVG from "react-svg";
import moment from "moment";
import QrCode from "qrcode";
import classNames from "classnames";
import {style} from '../../../utils/image';
import wxUtil from '../../../utils/wx';
const {getShareUrl}  = wxUtil;

let qrCodes = {} as { [key: string]: string }; // 缓存
const getQrCode = async function (url: string) {
  if (qrCodes[url]) {
    return qrCodes[url];
  }
  const dataUrl = await QrCode.toDataURL(url, { margin: 2 });
  qrCodes[url] = dataUrl;
  return dataUrl;
};

const useQrCode = function (url: string) {
  const [dataUrl, setDataUrl] = useState("");
  useEffect(() => {
    getQrCode(url).then((data) => setDataUrl(data));
  }, [url]);
  return dataUrl;
};
/**
 * 和子涵讨论，关于时间的显示，前端采用下面的方案：

 跨天的，就只在“天”级别显示开始和结束（不考虑跨年的情况，也就是说跨年的话，也只显示起始的年）
 当天的，除了“天”以外，就额外显示一个开始时间的“小时:分钟”（不显示结束时间）
 */

const formatTime = function (start: string, end: string) {
  const startM = moment(start);
  const endM = moment(end);

  const year = startM.format("YYYY");
  // 当天
  if (startM.isSame(endM, "day")) {
    return {
      year,
      start2end: startM.format("MM-DD HH:mm"),
    };
  }
  return {
    year,
    start2end: startM.format("MM.DD") + "-" + endM.format("MM.DD"),
  };
};

interface ITemplateInfo {
  title: string;
  address: string;
  time: {
    year: string;
    start2end: string;
  };
  link: string;
  img: string;
  source?: any;
  total_uv?: number;
  // qrcode:string;
}

const getTemplateGalleryInfo = function (useRoot?:boolean) {
  const { start_time, end_time } = window.gallery;
  // const link = `${window.location.protocol}//${window.__hostname}/gti/${window.gallery.url_labeling}`;
  const link = getShareUrl(window.__share_use_root || useRoot);
  // const qrcode = await getQrCode(link);
  return {
    title: window.gallery.name, //标题
    address: window.gallery.galleryaddress, //地点
    time: formatTime(start_time, end_time),
    link,
    // qrcode,
  };
};

const DEFAULT_TEMPLATE_ICON = {
  // template1:require(`../../../svg/icon-template1.svg`),
  //  使用template1的icon, 但是实际上是template2的模板, 设计和实际没对上, 所以这算是一个临时的解决方案
  template2:require(`../../../svg/icon-template1.svg`),
  template3:require(`../../../svg/icon-template3.svg`),
  // template4:require(`../../../svg/icon-template4.svg`),
  // template5:require(`../../../svg/icon-template5.svg`),
} as any;

export const getTemplates = function () {
  const templates = Array(5)
    .fill("template")
    .map((one, index) => `${one}${index + 1}`);
  // 注意，历史原因，这里的key和id不要随便变更(key其实是template+id)，部分代码都有使用
  const tmpList = templates.map((tmp, index) => ({
    id: index + 1, //从1开始
    key: tmp,
    src: DEFAULT_TEMPLATE_ICON[tmp]
  }));
  return tmpList;
};
const Template1 = function (props: ITemplateInfo) {
  const { title, address, time, link, img } = props;
  const qrcode = useQrCode(link);
  return (
    <>
      <div className="block">{title}</div>
      <img className={"main-img"} src={img} />
      <div className="block template-bottom">
        <div className="date">
          <div className={"year"}>{time.year}</div>
          <div className={"day"}>{time.start2end}</div>
        </div>
        <div className="horizon-line" />
        <div className="address">{address}</div>
        <div className="horizon-line" />
        <div className="right-col">
          <img className={"qrcode"} src={qrcode} />
          <img className="arrow" src={require('../../../assets/template_arrow.jpg')} />
          <div className={"tip"}>
            <p>扫码观看</p>
            <p>照片直播</p>
          </div>
        </div>
      </div>
    </>
  );
};

const Template2 = function (props: ITemplateInfo) {
  const { title, address, time, link, img, total_uv} = props;
  const qrcode = useQrCode(link);
  return (
    <>
      <div className="block">{title}</div>
      {window.__share_show_view ? <div style={{margin:`0 0 30px`, color:`#585869`}}>{total_uv || 1}人正在观看</div> : null}
      <img className={"main-img"} src={img} />
      <div className="center">
        <div className="year">
          # {time.year} {time.start2end} #
        </div>
        <div className="address">{address}</div>
        <img className={"qrcode"} src={qrcode} />
        <div className="tip">扫码观看直播</div>
      </div>
    </>
  );
};

const Template3 = function (props: ITemplateInfo) {
  const { title, address, time, link, img } = props;
  const qrcode = useQrCode(link);
  return (
    <>
      <img className={"main-img"} style={{ paddingTop: 30 }} src={img} />
      <div className="template-bottom">
        <div className="left-side">
          <div className="title">{title}</div>
          <div className="day">
            {time.year} {time.start2end}
          </div>
          <div className="address">{address}</div>
        </div>
        <div className="right-side">
          <img className={"qrcode"} src={qrcode} />
          <div className="tip">扫码观看直播</div>
        </div>
      </div>
    </>
  );
};

const Template4 = function (props: ITemplateInfo) {
  const { title, address, time, link, img } = props;
  const qrcode = useQrCode(link);
  return (
    <>
      <div className="template-bottom">
        <div className="left-side">
          <div className="title">{title}</div>
          <div className="day">
            {time.year} {time.start2end}
          </div>
          <div className="address">{address}</div>
        </div>
        <div className="right-side">
          <img className={"qrcode"} src={qrcode} />
          <div className="tip">扫码观看直播</div>
        </div>
      </div>
      <img className={"main-img"} style={{ paddingTop: 30 }} src={img} />
    </>
  );
};

const Template5 = function (props: ITemplateInfo) {
  const { title, address, time, link, img } = props;
  const qrcode = useQrCode(link);
  return (
    <>
      <div className="template-main" style={{ paddingTop: 30 }}>
        <div className="left-side">
          <img className={"main-img"} src={img} />
        </div>
        <div className="right-side">
          <div className="year">{time.year}</div>
          <div className="day" style={{ marginBottom: 30 }}>
            {time.start2end}
          </div>
          <div className="address" style={{ marginBottom: 30 }}>
            {address}
          </div>
          <img className={"qrcode"} src={qrcode} />
          <div className="tip">扫码观看直播</div>
        </div>
      </div>
      <div className="block">{title}</div>
    </>
  );
};

const TemplateDiy = function (props: ITemplateInfo) {
  const { title, address, time, link, img, source} = props;

  const ratio = 0.6667;
  // 注意，实测发现用transform scale虽然也能实现，但是会对外层元素有影响，最终不好调整，因为scale不会引起页面的重排，占用的空间其实就是
  // scale之前的空间；用zoom可以避免这个问题，但是这个属性本身就是非标准的，未来可能会不被支持
  // 所以这里统一都直接 * ratio来实现了
  // 有问题的话，再考虑通过设置poster-main宽度750，然后做相关的考虑吧

  // comment-new: 不得不还是用zoom了，哎，太难了……
  // todo: 父级传入这些参数
  const domStyle = {
    left: Number(source.x) * ratio,
    top: Number(source.y) * ratio,
    width: Number(source.width) * ratio,
    height: Number(source.height) * ratio,
    backgroundImage: `url(https:${img})`,
  };
  return (
    <>
      <img src={style(source.template, 'wx_750_n')} alt={""} className={"bg"} />
      <div className={"content"} style={domStyle} />
    </>
  );
};

const renderTemplateChildren = function (props: {
  templateId: number;
  img: string;
  source?: any;
  total_uv?: number;
  useRoot?: boolean;
}) {
  const { templateId, useRoot } = props;
  let info = getTemplateGalleryInfo(useRoot) as ITemplateInfo;
  info.img = props.img;
  if (!templateId) {
    console.warn("no templateId", templateId);
    return null;
  }
  console.log(props);
  switch (props.templateId) {
    case 1:
      return <Template1 {...info} />;
    case 2:
      return <Template2 {...info} total_uv={props.total_uv} />;
    case 3:
      return <Template3 {...info} />;
    case 4:
      return <Template4 {...info} />;
    case 5:
      return <Template5 {...info} />;
    // 其他情况都是DIY的
    default:
      return <TemplateDiy {...info} source={props.source} />;
  }
};
export const TemplateComponent = forwardRef<
  HTMLDivElement,
  {
    templateId: number;
    img: string;
    source?: any;
    total_uv?: number;
    useRoot?:boolean;
  }
>(function (props, ref) {

  return (
    <div
      className={classNames("poster-template", `template${props.templateId}`, Number(props.templateId) >= 1000 ? 'diy' : '')}
      ref={ref}
    >
      {renderTemplateChildren(props)}
    </div>
  );
});
